import React, { useEffect } from "react";

import {
  addDoc,
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
} from "@firebase/firestore";

import { firestore } from "../../firebase";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
  Grid,
} from "@chakra-ui/react";
import { Table } from "antd";
import Loader from "../../Components/Common/Loader";

import { FiEdit } from "react-icons/fi";
import { AiFillDelete } from "react-icons/ai";

const Inputs = () => {
  const [inputs, setInputs] = React.useState<any>([]);

  const [inputData, setInputData] = React.useState<any>({
    type: "",
    label: "",
    options: [],
    multiplier: 0,
    deleted: false,
  });

  const [loading, setLoading] = React.useState(false);

  const getInputValues = async () => {
    const ref = collection(firestore, "inputs");

    const newquery: any = query(ref, where("deleted", "!=", true));

    try {
      setLoading(true);
      const docSnap: any = await getDocs(newquery);

      if (docSnap.docs.length > 0) {
        let localDoc = [];
        for (const doc of docSnap.docs) {
          localDoc.push({ ...doc.data(), id: doc.id });
        }
        localDoc.map((item: any) => {
          if (item?.type === "slider") {
            item.value = 30;
          } else if (item?.type === "radio") {
            item.value = item.options[0].multiplier;
          } else if (item?.type === "input") {
            item.value = 0;
          }
        });
        setInputs(localDoc);
      }
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  const saveInput = async () => {
    const ref = collection(firestore, "inputs");

    try {
      setLoading(true);
      const docSnap: any = await addDoc(ref, inputData);
      getInputValues();
      closeModal();
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  const updateInput = async () => {
    const item = inputData;

    delete item.update;

    const ref = doc(firestore, "inputs", item.id);

    try {
      setLoading(true);
      const docSnap: any = await updateDoc(ref, item);
      getInputValues();
      closeModal();
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const deleteInput = async (id: string) => {
    const ref = doc(firestore, "inputs", id);

    try {
      setLoading(true);
      const docSnap: any = await updateDoc(ref, { deleted: true });
      getInputValues();
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setInputData({
      type: "",
      label: "",
      options: [],
      multiplier: 0,
    });
    onClose();
  };

  useEffect(() => {
    getInputValues();
  }, []);

  const { isOpen = true, onOpen, onClose } = useDisclosure();

  const colums = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text: any, record: any) => {
        return <Text textTransform={"capitalize"}>{record.type}</Text>;
      },
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Action",
      render: (text: any, record: any) => {
        return (
          <Flex gap={"10px"}>
            <IconButton
              aria-label="Edit"
              icon={<FiEdit size={20} className="text-[#000]" />}
              onClick={() => {
                onOpen();
                setInputData({ ...record, update: true });
              }}
            />
            <IconButton
              aria-label="Delete"
              icon={<AiFillDelete size={20} className="text-[#000]" />}
              onClick={() => {
                deleteInput(record.id);
              }}
            />
          </Flex>
        );
      },
    },
  ];

  return (
    <Box px={"50px"}>
      {loading && <Loader />}

      <Flex w={"100%"} pb={"45px"}>
        <Text fontSize="2xl" fontWeight="bold" mb="4">
          Inputs
        </Text>
        <Button
          colorScheme="black"
          variant="outline"
          ml={"auto"}
          onClick={() => {
            onOpen();
          }}
        >
          + Add Input
        </Button>
      </Flex>

      <Table columns={colums} dataSource={inputs} />

      <Modal isOpen={isOpen} onClose={closeModal} size={"3xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{inputData.update ? "Update" : "Add"} Input</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box display={"flex"} flexDirection={"column"} gap={"5px"}>
              <Text fontSize={"xl"} fontWeight={"semibold"}>
                Type
              </Text>
              <Text fontSize={"sm"} fontWeight={"500"}>
                Select the type of input you want to add
              </Text>
              <Select
                placeholder="Select option"
                onChange={(e) => {
                  setInputData({
                    ...inputData,
                    type: e.target.value,
                  });
                }}
                value={inputData.type}
              >
                <option value="input">Input</option>
                <option value="radio">Radio</option>
                <option value="slider">Slider</option>
              </Select>
            </Box>

            <Box
              display={"flex"}
              gap={"5px"}
              flexDirection={"column"}
              mt={"20px"}
            >
              <Text fontSize={"md"} fontWeight={"500"}>
                Label
              </Text>
              <Input
                placeholder={"Enter the Label"}
                type="text"
                onChange={(e) => {
                  setInputData({
                    ...inputData,
                    label: e.target.value,
                  });
                }}
                value={inputData.label}
              />
            </Box>

            {inputData.type === "radio" && (
              <Box mt={"20px"}>
                <Text fontSize={"xl"} fontWeight={"semibold"}>
                  Options
                </Text>

                <Box
                  py={"15px"}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"15px"}
                >
                  {inputData.options.map((item: any, index: number) => {
                    return (
                      <Grid templateColumns={"2fr 1fr"} gap={"10px"}>
                        <Input
                          placeholder={"Label"}
                          onChange={(e) => {
                            const temp = inputData.options;
                            temp[index].label = e.target.value;
                            setInputData({
                              ...inputData,
                              options: temp,
                            });
                          }}
                          value={item.label}
                        />
                        <Box display={"flex"} gap={"10px"}>
                          <Input
                            placeholder={"Multiplier"}
                            type="number"
                            onChange={(e) => {
                              const temp = inputData.options;
                              temp[index].multiplier = e.target.value;
                              setInputData({
                                ...inputData,
                                options: temp,
                              });
                            }}
                            value={item.multiplier}
                          />

                          <IconButton
                            aria-label="Edit"
                            icon={
                              <AiFillDelete size={20} className="text-[#000]" />
                            }
                            onClick={() => {
                              const temp = inputData.options;
                              temp.splice(index, 1);
                              setInputData({
                                ...inputData,
                                options: temp,
                              });
                            }}
                          />
                        </Box>
                      </Grid>
                    );
                  })}
                </Box>

                <Text
                  fontSize={"sm"}
                  fontWeight={"500"}
                  cursor={"pointer"}
                  onClick={() => {
                    setInputData({
                      ...inputData,
                      options: [
                        ...inputData.options,
                        {
                          label: "",
                          multiplier: 0,
                        },
                      ],
                    });
                  }}
                >
                  + Add options
                </Text>
              </Box>
            )}

            {inputData.type === "slider" && (
              <>
                <Box
                  display={"flex"}
                  gap={"5px"}
                  flexDirection={"column"}
                  mt={"20px"}
                >
                  <Text fontSize={"md"} fontWeight={"500"}>
                    Multiplier
                  </Text>
                  <Input
                    placeholder={"Multiplier"}
                    type="number"
                    value={inputData.multiplier}
                    onChange={(e) => {
                      setInputData({
                        ...inputData,
                        multiplier: e.target.value,
                      });
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  gap={"5px"}
                  flexDirection={"column"}
                  mt={"20px"}
                >
                  <Text fontSize={"md"} fontWeight={"500"}>
                    Min
                  </Text>
                  <Input
                    placeholder={"Min Value"}
                    type="number"
                    value={inputData.min}
                    onChange={(e) => {
                      setInputData({
                        ...inputData,
                        min: e.target.value,
                      });
                    }}
                  />
                </Box>
                <Box
                  display={"flex"}
                  gap={"5px"}
                  flexDirection={"column"}
                  mt={"20px"}
                >
                  <Text fontSize={"md"} fontWeight={"500"}>
                    Max
                  </Text>
                  <Input
                    placeholder={"Max Value"}
                    type="number"
                    value={inputData.max}
                    onChange={(e) => {
                      setInputData({
                        ...inputData,
                        max: e.target.value,
                      });
                    }}
                  />
                </Box>
              </>
            )}

            {inputData.type === "input" && (
              <Box
                display={"flex"}
                gap={"5px"}
                flexDirection={"column"}
                mt={"20px"}
              >
                <Text fontSize={"md"} fontWeight={"500"}>
                  Multiplier
                </Text>
                <Input
                  placeholder={"Multiplier"}
                  type="number"
                  value={inputData.multiplier}
                  onChange={(e) => {
                    setInputData({
                      ...inputData,
                      multiplier: e.target.value,
                    });
                  }}
                />
              </Box>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="black"
              variant="outline"
              mr={3}
              onClick={closeModal}
            >
              Close
            </Button>
            <Button
              bg={"black"}
              color={"white"}
              onClick={() => (inputData?.update ? updateInput() : saveInput())}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Inputs;
